<template>
  <ExternalLinkIcon :class="iconColor" />
</template>

<script>
import { ExternalLinkIcon } from "@heroicons/vue/outline";

export default {
    name: 'LinkIcon',
    components:{
        ExternalLinkIcon
    },
    props:{
        iconColor:{
            type: String,
            default: "text-purpleCust-390"
        }
    }
};
</script>
